export default __webpack_public_path__ + "static/media/access-management.41fdde99.svg";